var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("simple-header", { attrs: { header: _vm.$root.content.header } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "wrapper__entries" },
        _vm._l(_vm.partsToUse, function(part, i) {
          return _vm.partsToUse
            ? _c(
                "div",
                {
                  key: "entry-" + i,
                  staticClass: "entry",
                  style: {
                    opacity:
                      i === _vm.activeIndex
                        ? 1
                        : typeof _vm.activeIndex !== "number"
                          ? 1
                          : 0.6
                  },
                  on: {
                    click: function($event) {
                      _vm.toggle(i)
                    }
                  }
                },
                [
                  _c(
                    "item-top-slot",
                    {
                      style: {
                        transition: "transform 300ms",
                        transform:
                          "scale(" +
                          (i === _vm.activeIndex
                            ? 1
                            : typeof _vm.activeIndex !== "number"
                              ? 1
                              : 0.9) +
                          ")"
                      },
                      attrs: {
                        active:
                          i === _vm.activeIndex
                            ? true
                            : typeof _vm.activeIndex !== "number"
                              ? true
                              : false
                      }
                    },
                    [
                      _c("team-top", {
                        attrs: { content: part, active: _vm.isActive(i) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "wrapper__bottom",
                      style: {
                        transition: i == _vm.activeIndex ? "" : "height 400ms",
                        height:
                          i === _vm.activeIndex ? _vm.openHeight + "px" : "0px"
                      }
                    },
                    [
                      _c(
                        "item-bottom-slot",
                        {
                          attrs: { active: i === _vm.activeIndex },
                          on: { bottomHeight: _vm.setOpenHeight }
                        },
                        [_c("team-bottom", { attrs: { content: part } })],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        })
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a7e4df8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7e4df8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/expandinggrid-dallym-teams.vue
// module id = null
// module chunks = 